v<template>
  <div>

    <modal
       name="modal-save-ok"
       transition="nice-modal-fade"
       :min-width="200"
       height="auto"
       :delay="100"
       :scrollable="true"
       >
      <div class="modal-content">
        <div class="modal-content-inside">
          <font-awesome-icon
             icon="check-circle"
             class="help-icon"
             />
          <h3>Merci</h3>
          <p>
            Pour ces informations, elles seront intégrées prochainement à la carte.
          </p>
        </div>
        <button
           type="button"
           class="button float-right"
           v-on:click="hideSaveOkModal"
           >
          <font-awesome-icon icon="check-circle" />
          OK
        </button>
      </div>
    </modal>

    <div class="grid-x grid-margin-x">
      <div class="cell small-12 small-order-2 medium-order-1 medium-8 large-9 large-order-1">
        <vue-element-loading
           :active="waitLoading"
           spinner="mini-spinner"
           color="#FF6700"
           />
        <map-field
           id="id_map"
           name="mapfield"
           ref="map"
           :options="{ customDrawControl: true }"
           :drawAllow="true"
           :drawRectangle="false"
           :drawPolygon="false"
           :drawCircle="false"
           :drawCircleMarker="false"
           :markers="allMarkers"
           :polylines="allPolylines"
           :polygons="polygons"
           :zoom="mapZoom"
           :lat="mapCenterLat"
           :lon="mapCenterLon"
           :clusterOptions="clusterOptions"
           v-on:draw-marker="drawMarker"
           v-on:draw-polyline="drawPolyline"
           />
      </div>
      <div class="cell small-12 small-order-1 medium-order-2 medium-4 large-3 large-order-2">
        <div class="legend">
          <div class="logo"></div>
          <img src="/static/img/logo-vvvb.png">
          <h1>Cartographie participative</h1>
          <hr>

          <div v-show="!editService && !editRoad">

            <p>Collaborez à la carte vélo du territoire en l’enrichissant de
            nombreuses informations : aménagements non-répertoriés, notation de
            la cyclabilité d’un tronçon, points noirs cyclables, services d’un
            vélociste.
            </p>

            <p>
              Vous souhaitez davantage d’informations et être guidé pour pouvoir
              utiliser cet outil ? Allez faire un tour sur notre FAQ&nbsp;:
              «&nbsp;<a href="https://www.velo-et-voie-verte-en-beaujolais.fr/fr/carte-participative/"
              target="_blank">lien FAQ</a>&nbsp;»
            </p>

            <div class="legend">
              <hr>
              <h2>Légende</h2>

              <table>
                <tr><td align="center"><div class="legend-line legend-vvvb"></div></td><td>Voie Verte du Beaujolais</td></tr>
                <tr><td align="center"><div class="legend-line legend-ac"></div></td><td>Aménagements cyclables</td></tr>
                <tr><td align="center"><div class="legend-line legend-vr"></div></td><td>Voies de rabattement</td></tr>
                <tr><td align="center"><div class="legend-line legend-va"></div></td><td>Voiries apaisées (zones 30, zones de rencontre…)</td></tr>

                <tr><td align="center"><img width="20" src="/static/img/marker-icon-2x-parking.png"></td><td>Parking vélo sécurisé</td></tr>
                <tr><td align="center"><img width="12" src="/static/img/marker-icon-2x-circle-purple.png"></td><td>Arceaux vélo</td></tr>
                <tr><td align="center"><img width="20" src="/static/img/marker-icon-2x-bike.png"></td><td>Vélocistes</td></tr>
                <tr><td align="center"><img width="30" src="/static/img/marker-black-flag.png"></td><td>Points noirs</td></tr>
              </table>
            </div>

          </div>

          <div v-show="editService">
            <h2>Proposition d'un point remarquable</h2>

            <label>Nature du point</label>
            <v-select  v-model="editedService.nature" :options="serviceType" v-on:input="serviceNatureChanged" />
            <label>Commentaire</label>
            <textarea v-model="editedService.comment" placeholder="Votre commentaire…"></textarea>
            <label>Information de contact</label>
            <textarea v-model="editedService.contactInformation" placeholder="Vos informations de contact…"></textarea>
            <p><i>Ces informations ne seront pas communiquées à des tiers et ne seront utilisée que dans le cadre du projet.</i></p>
            <div class="grid-x grid-margin-x buttons">
              <div class="small-12  cell">
                <action-link
                   class="color-link"
                   @click="cancelMarker"
                   label="Annuler"
                   icon="angle-left"
                   />

                <button
                   type="button"
                   class="submit button success float-right"
                   :class="{ disabled: !maySaveMarker }"
                   @click.prevent="saveMarker"
                   >
                  <font-awesome-icon icon="file-import" />
                  Enregistrer
                </button>
              </div>
            </div>

          </div>

          <div v-show="editRoad">
            <h2>Proposition d'un tronçon</h2>
            <label>Nature de la voie</label>
            <v-select  v-model="editedRoad.nature" :options="roadType" v-on:input="roadNatureChanged" />
            <label>Qualité de l'aménagement</label>
            <v-select  v-model="editedRoad.note" :options="roadNote" />
            <label>Commentaire</label>
            <textarea v-model="editedRoad.comment" placeholder="Votre commentaire…"></textarea>
            <label>Information de contact</label>
            <textarea v-model="editedRoad.contactInformation" placeholder="Vos informations de contact…"></textarea>
            <p><i>Ces informations ne seront pas communiquées à des tiers et ne seront utilisée que dans le cadre du projet.</i></p>
            <div class="grid-x grid-margin-x buttons">
              <div class="small-12  cell">
                <action-link
                   class="color-link"
                   @click="cancelPolyline"
                   label="Annuler"
                   icon="angle-left"
                   />

                <button
                   type="button"
                   class="submit button success float-right"
                   :class="{ disabled: !maySavePolyline }"
                   @click.prevent="savePolyline"
                   >
                  <font-awesome-icon icon="file-import" />
                  Enregistrer
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { utils } from '@/utils';
// import { store } from '@/store';
import apiClient from '@/api/api';
import VueElementLoading from 'vue-element-loading';
import vSelect from 'vue-select';
import ActionLink from '@/components/action_link';

import MapField from '@/components/map_field';
import { handleFormErrorsMixin } from '@/mixins/handle_form_errors_mixin';
// import SectionTitle from '@/components/section_title';
// import CheckboxField from '@/components/checkbox_field';
// import Vue2Leaflet from 'vue2-leaflet';
// var { L } = Vue2Leaflet;

export default {
    name: 'Home',
    // store,
    mixins: [ handleFormErrorsMixin ],
    components: {
        ActionLink,
        // CheckboxField,
        MapField,
        // SectionTitle,
        VueElementLoading,
        vSelect,
    },
    props: {},
    data() {
        return {
            mapCenterLat: 46.12185666965474,
            mapCenterLon: 4.6741676330566415,
            mapZoom: 13,
            waitLoading: false,
            markers: [],
            editedMarker: {},
            polylines: [],
            editedPolyline: null,
            polygons: [],
            clusterOptions: {
                disableClusteringAtZoom: 12,
            },
            editService: false,
            editedService: { nature: '', comment: '', contactInformation: '' },
            editRoad: false,
            editedRoad: { nature: '', note: null, comment: '', contactInformation: '' },
            serviceType: [
                { value: 'parking', label: 'Stationnement vélo (arceaux ou abris sécurisés)' },
                { value: 'bike_shop', label: 'Vélociste (réparateur, vendeur, association)' },
                { value: 'blackflag', label: 'Point noir' },
            ],
            roadType: [
                { value: 'nothing', label: 'Pas d’aménagement' },
                { value: 'cycling_arrangement', label: 'Aménagement cyclable (piste ou bande cyclable, double-sens cyclable) ou voirie partagée avec d’autres modes doux (voie verte, aire piétonne, trottoir mixte vélos-piétons)' },
                { value: 'soothing_road', label: 'Voirie apaisée (zone 30 ou zone de rencontre)' },
            ],
            roadNote: [
                { value: '1', label: 'Cyclabilité mauvaise' },
                { value: '2', label: 'Cyclabilité moyenne' },
                { value: '3', label: 'Cyclabilité bonne' },
            ],
        };
    },
    computed: {
        allMarkers: function() {
            let all = utils.deepCopy(this.markers);
            if (this.editedMarker !== null) {
                all.push(this.editedMarker);
            }
            return all;
        },
        allPolylines: function() {
            let all = utils.deepCopy(this.polylines);
            if (this.editedPolyline !== null) {
                all.push(this.editedPolyline);
            }
            return all;
        },
        maySaveMarker: function() {
            return this.editedService.nature.value !== undefined && this.editedService.nature.value !== null;
        },
        maySavePolyline: function() {
            return this.editedRoad.nature.value !== undefined &&
                this.editedRoad.nature.value !== null &&
                this.editedRoad.note.value !== undefined &&
                this.editedRoad.note.value !== null;
        },
    },
    mounted: function() {
        this.getMarkers();
        this.getPolylines();
        this.getPolygons();
    },
    methods: {
        getMarkers: function() {
            apiClient.getMarkers()
                .then(response => {
                    this.markers = utils.deepCopy(response);
                });
        },
        getPolylines: function() {
            apiClient.getPolylines()
                .then(response => {
                    this.polylines = utils.deepCopy(response);
                });
        },
        getPolygons: function() {
            apiClient.getPolygons()
                .then(response => {
                    this.polygons = utils.deepCopy(response);
                });
        },
        showSaveOkModal: function() {
            this.$modal.show('modal-save-ok');
        },
        hideSaveOkModal: function() {
            this.$modal.hide('modal-save-ok');
        },
        drawPolyline: function(layer) {
            console.log(layer);
            this.editedRoad = { nature: '', comment: '' };
            this.editRoad = true;
            // this.$refs.map.addLayerToMap(layer);
            let latlngs = layer._latlngs;
            this.editedPolyline = {
                id: -1,
                pk: -1,
                latlngs: latlngs,
                style: {
                    'color': '#880000',
                    'opacity': 0.9,
                    'weight': 3,
                    'fill': false,
                },
            };
            // this.showServiceCreateModal();
        },
        cancelPolyline: function() {
            this.editRoad = false;
            this.editedPolyline = {};
            this.editedRoad = { nature: '', note: null, comment: '' };
        },
        savePolyline: function() {
            let obj = {
                note: this.editedRoad.note.value,
                comment: this.editedRoad.comment,
                latlngs: this.editedPolyline.latlngs,
                nature: this.editedRoad.nature.value,
                contactInformation: this.editedRoad.contactInformation,
            };
            apiClient.saveRoad(utils.deepCopyAndSnakeCase(obj))
                .then(response => {
                    this.editedRoad = { nature: '', note: null, comment: '', contactInformation: '' };
                    this.editRoad = false;
                    this.showSaveOkModal();
                })
                .catch((error) => {
                    // this.waitSaving = false;
                    this.handleFormErrors(error);
                });
        },
        roadNatureChanged: function() {
            if (this.editedRoad.nature.value === 'nothing') {
                this.editedPolyline.style.color = '#04048b';
            } else if (this.editedRoad.nature.value === 'cycling_arrangement') {
                this.editedPolyline.style.color = '#35cd35';
            } else if (this.editedRoad.nature.value === 'soothing_road') {
                this.editedPolyline.style.color = '#fed704';
            }
        },
        drawMarker: function(layer) {
            console.log(layer);
            this.editedService = { nature: '', comment: '' };
            this.editService = true;
            // this.$refs.map.addLayerToMap(layer);
            let lat = layer._latlng.lat;
            let lng = layer._latlng.lng;
            this.editedMarker = {
                id: -1,
                pk: -1, // layer._leaflet_id,
                latlng: [lat, lng],
                icon: 'green',
            };
            // this.showServiceCreateModal();
        },
        cancelMarker: function() {
            this.editService = false;
            this.editedMarker = {};
            this.editedService = { nature: '', comment: '' };
        },
        saveMarker: function() {
            let obj = {
                icon: this.editedMarker.icon,
                latlng: this.editedMarker.latlng,
                comment: this.editedService.comment,
                contactInformation: this.editedService.contactInformation,
            };
            apiClient.saveService(utils.deepCopyAndSnakeCase(obj))
                .then(response => {
                    this.markers.push(this.editedMarker);
                    this.editedService = { nature: '', comment: '', contactInformation: '' };
                    this.editService = false;
                    this.editedMarker = {};
                    this.showSaveOkModal();
                })
                .catch((error) => {
                    // this.waitSaving = false;
                    this.handleFormErrors(error);
                });
        },
        serviceNatureChanged: function() {
            if (this.editedService.nature.value === 'parking') {
                this.editedMarker.icon = 'parking';
            } else if (this.editedService.nature.value === 'bike_shop') {
                this.editedMarker.icon = 'bike';
            } else if (this.editedService.nature.value === 'blackflag') {
                this.editedMarker.icon = 'blackflag';
            }
        },
    },
};

</script>

<style lang="stylus" scoped>
.modal-content
    padding: 1rem
.modal-content-inside
    min-height: 220px

textarea
    height: 8rem

#id_map
    height: 100vh

.legend
    padding-top: 1rem
    padding-right: 1rem

.section-title-container
    margin-top: 2rem

.legend-color
    text-align: center
    .legend-color-block
    .legend-color-text
        min-width: 0.7rem
        height: 1rem
        display: inline-block
    .legend-color-text
        font-size: 10px

.checkbox-field
    margin-top: 0.5rem

.map-icons
    margin-left: 0.5rem

.legend
    padding-top: 0rem

.legend-line
    width: 2rem
    height: 5px
    margin-right: 0.5rem
    margin-left: 0.5rem

.legend-vvvb
    background-color: #006400

.legend-ac
    background-color: #53af35

.legend-vr
    background-color: #f59e37

.legend-va
    background-color: #e8d366

</style>
